module.exports = __webpack_public_path__ + "img/icon1.b0bf2e55.png";